/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZD0iTTE1LjQ5IDYuNDlWMS41SDEwLjVWMy41SDUuNVYxLjVIMC41MTAwMDJWNi40OUg1LjVWNC42MUM2LjIzIDQuODggNy41IDUuOCA3LjUgOUM3LjUgMTEuNDIgOS4yNSAxMi4yOCAxMC41IDEyLjQ2VjE0LjVIMTUuNDlWOS41MUgxMC41VjExLjQ1QzkuNzYgMTEuMzEgOC41IDEwLjgxIDguNSA5QzguNSA2LjYyIDcuODMgNS4yNyA3LjA4IDQuNUgxMC41VjYuNDlIMTUuNDlaTTQuNSA1LjQ5SDEuNTFWMi41SDQuNVY1LjQ5Wk0xMS41IDEwLjUxSDE0LjQ5VjEzLjVIMTEuNVYxMC41MVpNMTEuNSAyLjVIMTQuNDlWNS40OUgxMS41VjIuNVoiIGZpbGw9ImluaGVyaXQiLz4=";